<template>
  <component
    :is="tag"
    v-bind="buttonProps"
    class="s-button s-button-icon"
    :class="{
      [`s-button-icon--size-${size}`]: true,
      [`s-button--action-${actionType}`]: true,
      [`s-button--color-${color}`]: true,
      's-button--disabled': disabled,
      's-button--opaque': opaque,
      's-button--rounded': rounded,
    }"
    @click="click"
  >
    <SButtonStyles />
    <i class="s-button-icon__icon" :class="icon" />
  </component>
</template>

<script setup lang="ts">
import type { UseButtonIconEmit } from "@/lib/components/logic/atoms/useButtonIcon";

import * as useButtonIcon from "@/lib/components/logic/atoms/useButtonIcon";

import SButtonStyles from "./SButtonStyles.vue";

const props = defineProps(useButtonIcon.props);
const emit = defineEmits<UseButtonIconEmit>();

const { icon, tag, buttonProps, click, disabled } = useButtonIcon.use(
  props,
  emit,
);
</script>

<style lang="postcss">
.s-button-icon {
  @apply shrink-0;

  &--size {
    &-lg {
      @apply h-12 w-12;

      .s-button-icon__icon {
        @apply h-5 w-5;
      }
    }

    &-md {
      @apply h-10 w-10;

      .s-button-icon__icon {
        @apply h-4 w-4;
      }
    }

    &-sm {
      @apply h-8 w-8;

      .s-button-icon__icon {
        @apply h-3.5 w-3.5;
      }
    }

    &-xs {
      @apply h-6 w-6;

      .s-button-icon__icon {
        @apply h-3 w-3 text-sm;
      }
    }

    &-inline {
      @apply -mx-1 inline-flex h-6 w-6;

      .s-button-icon__icon {
        @apply h-4 w-4;
      }
    }
  }
}
</style>
